import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, FontWeight, Spacing } from "@snapchat/snap-design-system";

export const NavigationIcon = styled.img`
    width: 18px;
    height: 18px;
`;

export const tokenIcon = css`
    height: ${Spacing.LG}px;
`;

export const warningIcon = css`
    margin-left: 5px;
`;

export const teamMembersIconCss = css`
    width: ${Spacing.MD}px;
    height: ${Spacing.MD}px;
`;

export const externalLinkCss = css`
    font-size: ${FontSizeInPx.COMPACT}px;
    font-weight: ${FontWeight.MEDIUM};
    color: ${Colors.Black.V100};
`;

export const sectionDividerCss = css`
    padding-top: ${Spacing.MD}px;
    border-top: 1px solid ${Colors.Gray.V200};
`;
